import {Directive, Input} from '@angular/core';
import {AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn} from "@angular/forms";
import {NgbDate} from "@ng-bootstrap/ng-bootstrap";

/**
 * The start date must be before the end date.
 */
@Directive({
  selector: '[startDateBeforeEndDate]',
  providers: [{provide: NG_VALIDATORS, useExisting: StartDateBeforeEndDateValidatorDirective, multi: true}]
})
export class StartDateBeforeEndDateValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
    return startDateBeforeEndDateValidator(control);
  };
}

/**
 * Validator function to check that the season end date is after the season start date.
 * @param control
 */
export const startDateBeforeEndDateValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const ss = control.get('start-date');
  const se = control.get('end-date');
  if (ss && se && ss.value && se.value ) {
    const seasonStartDate = new NgbDate(ss.value.year, ss.value.month, ss.value.day);
    const seasonEndDate = new NgbDate(se.value.year, se.value.month, se.value.day);
    if (seasonStartDate !== null && seasonEndDate !== null) {
      if (seasonEndDate.before(seasonStartDate)) {        
        return {'startDateBeforeEndDate': {value:  true}};
      }
    }
  }
  return null;
};


